import React, { useCallback, useContext, useEffect, useState } from 'react';
import { curatorsChat } from '../../http/СhatAPI'
import { observer } from "mobx-react-lite";
import { Context } from '../..';
import { FiSearch } from "react-icons/fi";
import menu from '../../utils/menu.svg'
import avatar from "../../utils/Avatar.svg";
import dayjs from "dayjs";

import ChatRoom from './components/CuratorChatRoom';
import CuratorChatHeader from './components/CuratorChatHeader'

const CuratorChat = observer(() => {
    const { user } = useContext(Context);
    const [currentRoom, setCurrentRoom] = useState(null);
    const [rooms, setRooms] = useState([]);
    const [showSidebar, setShowSidebar] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");
    const [lastMessage, setLastMessage] = useState({});

    let h = true;

    async function fetchChats() {
        const response = await curatorsChat();
        setRooms(response);
    }

    useEffect(() => {
        fetchChats();
    }, []);

    const filteredRooms = rooms.filter((room) =>
        room.members?.[0]?.first_name?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const getLastM = useCallback((lastm) => {
        if (Array.isArray(lastm) && lastm.length > 0) {
            const lastMsg = lastm[lastm.length - 1];
            setLastMessage(lastMsg);
            return lastMsg;
        } else if (lastm && typeof lastm === 'object') {
            console.log("Single message object:", lastm);
            setLastMessage(lastm);
            return lastm;
        } else {
            console.warn("Invalid or empty lastm:", lastm);
            setLastMessage(null);
            return null;
        }
    }, []);

    const formatTimestamp = (timestamp) => {
        if (!timestamp) return '';
        return dayjs(timestamp).format("HH:mm");
    };

    return (
        <div className="flex h-screen overflow-hidden">
            {/* Боковая панель чатов */}
            <div
                className={`fixed top-0 left-0 h-full bg-white border-r border-gray-200 flex flex-col z-40 transition-transform duration-300 ease-in-out ${
                    showSidebar ? "translate-x-0 w-80" : "-translate-x-full"
                }`}
            >
                {/* Хэдер панели (sticky) */}
                <div className="p-4 border-b border-gray-200 flex items-center h-20 sticky top-0 bg-white z-50">

                        <button
                            className="mr-4 p-2 "
                            onClick={() => setShowSidebar(!showSidebar)}
                        >
                            <img src={menu} alt="menu"/>
                        </button>


                    <div className="relative flex-1">
                        <FiSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-[#6446C3]"/>
                        <input
                            type="text"
                            placeholder="Поиск"
                            className="w-full h-[42px] pl-12 pr-4 py-3 bg-[#EBEBFA] text-[#6446C3] placeholder-[#6446C3] border border-transparent rounded-full focus:outline-none focus:ring-2 focus:ring-[#7A4CA0]"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            aria-label="Search contacts"
                        />
                    </div>
                </div>

                {/* Контакты - прокручиваемая зона */}
                <div className="flex-1 px-1 overflow-y-auto">
                    <div>{filteredRooms.length > 0 ? (
                            filteredRooms.map((room) => {
                                const member = room.members?.[0];
                                return (
                                    <div
                                        key={room.id}
                                        className={`flex items-center py-3 px-4 cursor-pointer ${
                                            currentRoom && currentRoom.id === room.id
                                                ? "bg-[#6446C3] rounded-2xl "
                                                : ""
                                        }`}
                                        onClick={() => setCurrentRoom(room)}
                                        role="button"
                                        tabIndex={0}
                                        aria-label={`Chat with ${member?.name || "Unknown"}`}
                                    >
                                        {/* Аватар */}
                                        <div className="relative">
                                            <img
                                                src={member?.avatar_url || avatar}
                                                alt={member?.first_name || "No name"}
                                                className="w-12 h-12 rounded-full object-cover"
                                            />
                                        </div>

                                        {/* Информация о контакте */}
                                        <div className="ml-4 flex-1">
                                            {/* Имя */}
                                            <h3
                                                className={`font-bold ${
                                                    currentRoom && currentRoom.id === room.id 
                                                        ? "text-white"
                                                        : "text-[#363645]"
                                                }`}
                                            >
                                                {member?.first_name || "Unknown"}
                                            </h3>

                                            {/* Дополнительная информация */}
                                            <p
                                                className={`text-sm ${
                                                    currentRoom ? "text-[#EBEBFA]" : "text-[#707991]"
                                                } truncate`}
                                            >
                                                {lastMessage.message || ""}
                                            </p>
                                        </div>

                                        {/* Время последнего сообщения */}
                                        <div
                                            className={`text-xs ${
                                                currentRoom
                                                    ? "text-[#EBEBFA]"
                                                    : "text-gray-500"
                                            }`}
                                        >
                                            {formatTimestamp(lastMessage.timestamp)}
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div className="text-center text-gray-500 mt-10">
                                Контакты не найдены
                            </div>
                        )}</div>
                </div>
            </div>

            {/* Чат */}
            <div className={`flex-1 transition-all duration-300 ease-in-out ${showSidebar ? "ml-80" : "ml-0"}`}>
                {user.role === 'curator' ? (
                        <CuratorChatHeader room={currentRoom} showSidebar={showSidebar} setShowSidebar={setShowSidebar}/>) :
                    <CuratorChatHeader room={currentRoom} showSidebar={showSidebar} setShowSidebar={setShowSidebar} h={h}/>}
                {currentRoom ? (
                    <ChatRoom room={currentRoom} getLastM={getLastM}/>
                ) : (
                    <div className="h-full flex items-center justify-center text-gray-500">
                        Выберите чат для отображения
                    </div>
                )}
            </div>
        </div>
    );
});

export default CuratorChat;